export function RequestIdleCallback() {
    window.requestIdleCallback = window.requestIdleCallback ||
        function (cb) {
            var start = Date.now();
            return setTimeout(function () {
                cb({
                    didTimeout: false,
                    timeRemaining() {
                        return Math.max(0, 50 - (Date.now() - start));
                    }
                });
            }, 1);
        };
}
//# sourceMappingURL=RequestIdleCallback.js.map